<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="scroll-box">
                <v-container class="modal-container">
                    <v-row>
                        <v-col>
                            <h1>Investimento</h1>
                            <v-row v-if="loading">
                                <v-col class="justify-center align-center">
                                    <v-progress-circular :size="35"
                                                        color="primary"
                                                        indeterminate />
                                </v-col>
                            </v-row>
                            <v-row class="command-col">
                                <v-col>
                                    <!--button type="button"
                                            v-if="source.transactions && source.transactions.length"
                                            title="Selectionar todas as transações para adição ao Kristal."
                                            :disabled="loading"
                                            @click="allTrans($event)">
                                        {{ getAllLabel() }}
                                    </button-->
                                    <button type="button"
                                            title="Selecionar investimento para adição ao Kristal"
                                            :class="getSelfClass()"
                                            :disabled="loading"
                                            @click="selfStatus($event)">
                                        {{ getSelfLabel() }}
                                    </button>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.name">
                                    <div>Nome: {{ source.name }}</div>
                                </v-col>
                                <v-col class="item-editable"
                                       :title="source.code"
                                       @click="editCode($event)">
                                    <div>Código: {{ source.code }}</div>
                                </v-col>
                                <v-col :title="source.isin">
                                    <div>Isin: {{ source.isin }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.status_imp">
                                    <div>Status: {{ source.status_imp }}</div>
                                </v-col>
                                <v-col :title="source.message_imp">
                                    <div>Mensagem: {{ source.message_imp }}</div>
                                </v-col>
                                <v-col :title="source.date_imp">
                                    <div>Data: {{ source.date_imp }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.number">
                                    <div>No.: {{ source.number }}</div>
                                </v-col>
                                <v-col :title="source.owner">
                                    <div>Propr.: {{ source.owner }}</div>
                                </v-col>
                                <v-col :title="source.currencyCode">
                                    <div>Moeda: {{ source.currencyCode }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.type">
                                    <div>Tipo: {{ source.type }}</div>
                                </v-col>
                                <v-col :title="source.subtype">
                                    <div>Subt.: {{ source.subtype }}</div>
                                </v-col>
                                <v-col :title="percentageHelper.formatStandard(source.lastMonthRate)">
                                    <div>T. últ. mês: {{ percentageHelper.formatStandard(source.lastMonthRate) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="percentageHelper.formatStandard(source.annualRate)">
                                    <div>T. anual: {{ percentageHelper.formatStandard(source.annualRate) }}</div>
                                </v-col>
                                <v-col :title="formatDate(source.date)">
                                    <div>Data: {{ formatDate(source.date) }}</div>
                                </v-col>
                                <v-col :title="currencyHelper.formatValue(source.value)">
                                    <div>Valor: {{ currencyHelper.formatValue(source.value) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.quantity">
                                    <div>Quantidade: {{ source.quantity }}</div>
                                </v-col>
                                <v-col :title="currencyHelper.formatValue(source.amount)">
                                    <div>Total: {{ currencyHelper.formatValue(source.amount) }}</div>
                                </v-col>
                                <v-col :title="source.taxes">
                                    <div>Taxas: {{ source.taxes }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.taxes2">
                                    <div>Tx. adic.: {{ source.taxes2 }}</div>
                                </v-col>
                                <v-col :title="currencyHelper.formatValue(source.balance)">
                                    <div>Saldo: {{ currencyHelper.formatValue(source.balance) }}</div>
                                </v-col>
                                <v-col :title="formatDate(source.dueDate)">
                                    <div>Vencimento: {{ formatDate(source.dueDate) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="percentageHelper.formatStandard(source.rate)">
                                    <div>Taxa: {{ percentageHelper.formatStandard(source.rate) }}</div>
                                </v-col>
                                <v-col :title="source.rateType">
                                    <div>Tp. Taxa: {{ source.rateType }}</div>
                                </v-col>
                                <v-col :title="percentageHelper.formatStandard(source.fixedAnnualRate)">
                                    <div>T. fix. anual: {{ percentageHelper.formatStandard(source.fixedAnnualRate) }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="source.issuer">
                                    <div>Emissor: {{ source.issuer }}</div>
                                </v-col>
                                <v-col :title="formatDate(source.issueDate)">
                                    <div>Emissão: {{ formatDate(source.issueDate) }}</div>
                                </v-col>
                                <v-col :title="source.amountProfit">
                                    <div>Lucro: {{ source.amountProfit }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :title="currencyHelper.formatValue(source.amountWithdrawal)">
                                    <div>Saque: {{ currencyHelper.formatValue(source.amountWithdrawal) }}</div>
                                </v-col>
                                <v-col :title="source.amountOriginal">
                                    <div>Original: {{ source.amountOriginal }}</div>
                                </v-col>
                                <v-col :title="source.status">
                                    <div>Status: {{ source.status }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :tite="source.institution && source.institution.name">
                                    <div>Nome b.: {{ source.institution && source.institution.name }}</div>
                                </v-col>
                                <v-col :tite="source.institution && source.institution.number">
                                    <div>No. b.: {{ source.institution && source.institution.number }}</div>
                                </v-col>
                                <v-col>&nbsp;</v-col>
                            </v-row>
                            <v-row class="data-table">
                                <v-col>
                                    <table v-if="source.transactions && source.transactions.length">
                                        <caption>Transações</caption>
                                        <thead>
                                            <tr>
                                                <th>Negociação</th>
                                                <th>Data</th>
                                                <th>Total</th>
                                                <th>Tipo</th>
                                                <th>Marcada?</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="transaction in source.transactions"
                                                :key="transaction.transactionId"
                                                @click="viewTransaction(transaction)">
                                                <td>{{ formatDateAbbr(transaction.tradeDate) }}</td>
                                                <td>{{ formatDateAbbr(transaction.date) }}</td>
                                                <td>{{ currencyHelper.formatValue(transaction.amount) }}</td>
                                                <td>{{ transaction.type }}</td>
                                                <td>
                                                    <input type="checkbox"
                                                            title="Status de seleção para adição ao Kristal"
                                                            :checked="transaction.import ? 'checked' : ''"
                                                            :disabled="loading"
                                                            @click="tgStatus($event, transaction)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>

        <v-btn icon
            class="close-btn"
            :disabled="loading"
            @click="$emit('close')">
            <img src="@/assets/icons/close.svg"
                alt="dashboard"
                class="icon" />
        </v-btn>

        <TransactionDetails v-if="displaying"
                            @close="displaying = false"
                            :source="target" />
    </div>
</template>

<style scoped>
.close-btn {
  position: fixed;
  top: 6%;
  right: 6%;
}
.modal-mask {
  position: fixed;
  z-index: 21;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0px auto;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-wrapper > .scroll-box {
  max-width: 90% !important;
  width: 90% !important;
  max-height: 90% !important;
  height: 90% !important;
  margin: auto;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  display: block;
}
.modal-container .row .col table {
    border: 1px solid black;
    border-collapse: collapse;
    width: 100%;
    font-size: 0.8rem;
}
.modal-container .row .col table caption {
    font-weight: bold;
    font-size: 1.5rem;;
}
.modal-container .row .col table thead tr th,
.modal-container .row .col table tbody tr td {
    padding: 0.25rem;
    cursor: pointer;
    width: 20%;
    text-align: center;
}
.modal-container .row .col table thead tr th {
    background-color: black;
    color: white;
}
.modal-container .row .col table tbody tr:nth-child(odd) {
    background-color: #DDDDDD;
}
.modal-container .row .col .row .col {
    height: 1.8rem;
}
.modal-container > .row > .col > .row > .col > div {
    width: 100%;
    min-width: 100%;
    overflow: hidden;
    height: 1.8rem;
    max-height: 1.8rem;
}
.modal-container .row .col .row.command-col .col {
    height: 4.5rem;
    min-height: 4.5rem;
    border-bottom: 2px solid rgba(0, 128, 0, .75);;
}
.modal-container .row .col .row.data-table .col {
    margin-top: 1rem;
    height: unset;
    min-height: fit-content;
    border-top: 2px solid rgba(0, 128, 0, .75);;
}
.modal-container .row .col button {
    background-color: rgba(0, 32, 32, .5);
    color: white;
    border-radius: 20px;
    padding: 0.7rem;
    margin: 0;
}
@media screen and (max-width: 1024px) {
    .close-btn {
        top: 1%;
        right: 6%;
    }
    .modal-container .row {
        flex-direction: column;
    }
    .modal-container .row .col .row .col {
        font-size: 0.75rem;
        height: unset;
        min-height: 1.8rem;
    }
    .modal-container .row .col button {
        padding: 0.35rem;
    }
    .modal-wrapper > .scroll-box {
        max-height: unset;
        height: unset;
        min-width: 100% !important;
        max-width: unset;
        width: unset;
        min-height: fit-content;
    }
    .modal-wrapper {
        display: block;
        height: 100%;
        width: 100%;
        overflow: scroll;
    }
}
.modal-container .row .col .row .col.item-editable div {
    background-color: #DDDDDD;
    border-radius: 4px;
    padding: 6px;
    margin: -6px;
    cursor: pointer;
}
</style>

<script lang="js">
import ApiService from '../../../../../services/ApiService';
import EventBus from '../../../../Bus/bus';
import currencyHelper from '../../../../../Utils/CurrencyHelper';
import percentageHelper from '../../../../../Utils/PercentageHelper';
import TransactionDetails from './TransactionDetails.vue';

export default          {
    props               : {
        source          : { type: Object }
    },
    data                () {
        return {
            currencyHelper,
            percentageHelper,
            apiService  : undefined,
            loading     : false,
            displaying  : false,
            target      : undefined
        };
    },
    components          : { TransactionDetails },
    methods             : {
        formatDate      (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`;
        },
        formatDateAbbr  (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return dt.toLocaleDateString();
        },
        viewTransaction (trans) {
            if (this.loading || !trans) { return; }
            this.displaying = true;
            this.target     = trans;
        },
        getAllLabel     () {
            const chk = this.source &&
                        this.source.transactions &&
                        this.source.transactions.length &&
                        this.source.transactions.every((t) => t.import);
            return chk ? 'Desmarcar todas as transações' : 'Selecionar todas as transações para adição ao Kristal';
        },
        async allTrans  (e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            this.loading = true;
            try {
                const part = this.source.transactions.some((t) => !t.import);
                const userId = this.$store.getters.$tokenUserSelected;
                const resp = await this.apiService.setInvestmentImportStatus(this.source, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                this.source.transactions.forEach((t) => t.import = part);
            } finally {
                this.loading = false
                return false;
            }
        },
        getSelfClass    () {
            if (!this.source) { return ''; }
            return this.source.status_imp === 'Marcado para importação.' ? 'item-checked' : 'item-unchecked';
        },
        getSelfLabel    () {
            //if (!this.source || (this.source.transactions && this.source.transactions.length)) { return ''; }
            return this.source.status_imp === 'Marcado para importação.' ? 'Limpar seleção de importação' : 'Selecionar investimento para adição ao Kristal';
        },
        async selfStatus(e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            if (this.source.transactions &&
                this.source.transactions.length &&
                !this.source.transactions.some((t) => t.import)) {
                const message = "Esse investimento possui transações mas você não marcou nenhuma. " +
                                "Marcar uma transação seleciona esse investimento automaticamente. " +
                                "Deseja marcar o investimento sem selecionar nenhuma transação?";
                if (!confirm(message)) { return; }
            }
            this.loading = true;
            const enable = this.source.status_imp === 'Marcado para importação.';
            try {
                const userId = this.$store.getters.$tokenUserSelected;
                const resp = await this.apiService.toggleTransImportStatus({
                    investmentId : this.source.investmentId,
                    transactionId: 0,
                    import       : enable
                }, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                this.source.status_imp = enable ?
                    'Não processado.' :
                    'Marcado para importação.';
                if (enable) {
                    this.source.message_imp = undefined;
                    this.source.date_imp = undefined;
                }
            } finally {
                this.loading = false
                return false;
            }
        },
        async tgStatus  (e, trans) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !trans) { return; }
            this.loading = true;
            try {
                const userId = this.$store.getters.$tokenUserSelected;
                const resp   = await this.apiService.toggleTransImportStatus(trans, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                trans.import = !trans.import;
            } finally {
                this.loading = false
                return false;
            }
        },
        editCode        (e) {
            e.cancelBubble = true;
            const call = {
                width  : 400,
                height : 300,
                view   : 'EditarCodigoInvestimento'
            };
            EventBus.$emit('openFloatModal', call, this.source);
        }
    },
    created             () {
        this.apiService = new ApiService();
    },
    mounted             () {

    },
    beforeDestroy       () {

    }
}
</script>